import UploadForm from 'views/bulkUpload/components/UploadForm/UploadForm';
import { SummarySubmitSection } from 'views/bulkUpload/UploadCatalog/components/SummarySubmitSection/SummarySubmitSection';
import { IUploadInfo } from 'views/bulkUpload/UploadCatalog/content/uploadCatalogInfo';

interface DownloadQuotesStep2Props {
  errors: string[];
  summaryUploadInfo: IUploadInfo;
  templateUrl: string;
  handleReturnToUpload: () => void;
}
const DownloadQuotesStep2 = ({
  errors,
  summaryUploadInfo,
  handleReturnToUpload,
  templateUrl
}: DownloadQuotesStep2Props) => {
  return (
    <UploadForm
      hideAlert
      hideFileInput
      uploadInfo={summaryUploadInfo}
      customSubmitSection={
        <SummarySubmitSection
          areErrors={!!errors?.length}
          errorTemplateURL={templateUrl}
          handleReturnToUpload={handleReturnToUpload}
          typeOfSummary="quotes"
        />
      }
      errors={errors}
    />
  );
};

export default DownloadQuotesStep2;
